module.exports = __webpack_public_path__ + "img/alert-img.bcbb8cf3.png";